export const SOCIAL = {
  instagram: "https://instagram.com/estesia.zentrum",
  facebook: "https://facebook.com/estesia.bern",
  email: "estesia.bern@gmail.com",
};

export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Estesia+Zentrum+f%C3%BCr+Spiritistische+Studien+Bern";
